export default __webpack_public_path__ + "static/media/pnsv_stand_Isuzu.29b4295c.png";